import { IonInput, IonLabel, IonNote } from "@ionic/react";
import React, { useState } from "react";
import "./Input.scss";

function Input(props: any) {
  const setValue = useState("")[1];
  const [isOpen, setIsOpen] = useState(false);
  const [isSelected, setIsSelected] = useState(false);

  const callBackFunction = (e: any) => {
    setValue(e.target.value);
    setIsOpen(e.target.value !== "");
    props.callBack(e);
  };

  const classes = ["input", isOpen || isSelected ? "input--open " : null, props.hidden ? "ion-hide" : null].filter((r) => r).join(" ");

  return (
    <div className={classes}>
      <div className="input__container">
        <IonInput
          name={props.name}
          value={props.value}
          type={props.type}
          className="input__input"
          onIonFocus={() => {
            setIsSelected(true);
          }}
          onIonBlur={() => {
            setIsSelected(false);
          }}
          onInput={(e) => callBackFunction(e)}
        />
        <IonLabel className="input__label">{props.placeholder}</IonLabel>
      </div>
      {props.error ? <IonNote color="danger">{props.error}</IonNote> : null}
    </div>
  );
}

// @ts-ignore
export default Input;
